import { APPLICATION_KEYS, type ApplicationKey } from './application-keys';

/**
 * The suite's own applications. These are part of the platform rather than
 * something an operator registers by hand, so the seed converges every
 * environment on the same registry.
 *
 * The urls here are the local ones, used when a row is first created. Nothing routes on
 * `Application.url`: where each application is served is `APPLICATION_URLS`, committed in
 * `application-urls.ts`, so no environment needs a url set by hand.
 */
export interface RegisteredApplication {
  key: ApplicationKey;
  name: string;
  description: string;
  url: string;
  icon: string;
  order: number;
  /** Roles that may open it. An empty list means everyone signed in. */
  roles: string[];
}

export const PLATFORM_APPLICATIONS: RegisteredApplication[] = [
  {
    key: APPLICATION_KEYS.projectManagement,
    name: 'Project Management',
    description: 'Clients, statements of work, projects, allocation and utilisation.',
    url: 'http://localhost:5173',
    icon: 'briefcase',
    order: 10,
    roles: [],
  },
  {
    key: APPLICATION_KEYS.onboarding,
    name: 'Onboarding',
    description: 'Candidates, the hiring workflow, signing and the employee record.',
    url: 'http://localhost:5175',
    icon: 'user-plus',
    order: 20,
    roles: [],
  },
  {
    key: APPLICATION_KEYS.training,
    name: 'Training',
    description: 'Questionnaires, assignments, attempts and certificates.',
    url: 'http://localhost:5177',
    icon: 'graduation-cap',
    order: 30,
    roles: [],
  },
  {
    key: APPLICATION_KEYS.syncConsole,
    name: 'Sync console',
    description: 'Zoho sync runs and the events each one wrote.',
    url: 'http://localhost:5176',
    icon: 'refresh-cw',
    order: 40,
    roles: [],
  },
  {
    key: APPLICATION_KEYS.platform,
    name: 'Platform',
    description: 'People, access and the directory sync.',
    url: 'http://localhost:5178',
    icon: 'blocks',
    order: 50,
    roles: [],
  },
];
